import axios from 'axios';
import React, { useContext, useRef, useState } from 'react'
import { init } from '../../auth/handleTokens';
import useAuth from '../../auth/useAuth';
import { constants } from '../../constants';
import NotificationContext from '../toasts/NotificationContext';
import TagInputs from './TagInputs';

import { isAndroid } from 'react-device-detect';

const ModalAuthMessage = ({idMessage, contentMessage, charactersCount, creditsCount}) => {

    const [sending, setSending] = useState(false);
    const [start, setStart] = useState(false);
    const [restartTags, setRestartTags] = useState(false);
    const {user} = useAuth();
    const {showNotification} = useContext(NotificationContext);

    const btnClose = useRef();
    const divCelphonesRef = useRef();
    const divGroupsRef = useRef();
    const divMessageCreateRef = useRef();

    const handleMessage = async() => {
        const result = await init()
        if(!result) return window.location.href = '/login'
        const token = window.localStorage.getItem('at');
        const URL = constants.test_host + '/sms/sendmessage'

        let celphones = [];
        let groups = [];
        const sms = divMessageCreateRef.current.textContent;
        const arrayCelphones= divCelphonesRef.current.childNodes[1].childNodes
        const arrayGroups= divGroupsRef.current.childNodes[1].childNodes
        const totalCredits = creditsCount;

        for (const item of arrayCelphones) {
            if(isAndroid) {
                celphones = item.value !== '' ? item.value.split(',') : []
            }
            if(item.className === "tag-item"){
                let num = item.textContent.replace('x', '');
                celphones.push(num);
            }
        }
        for (const item of arrayGroups) {
            if(item.className === "tag-item"){
                let num = item.textContent.replace('x', '');
                groups.push(num);
            }
        }

        if(celphones.length === 0 && groups.length === 0) {
            showNotification('failed', 'Debe ingresar los números de teléfono o grupos de contactos.')
        return
        }
        if(sms === '') {
            showNotification('failed', 'El contenido del mensaje no puede ser vacío!');
        return;
        }

        setSending(true);
        setRestartTags(!restartTags);

        await axios.post(URL, {celphones, groups, sms, totalCredits }, {headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`}, withCredentials: true})
        .then(({data}) => {
            showNotification('success', data.message)
            setSending(false);
            btnClose.current.click();
            })
        .catch(error => {
            showNotification('failed', error.response.data.message);
            setSending(false);
        })
        
      }
    

  return (
    <>
        <div className=' container modal-header'>
            
            <div className='modal-title'>
                <img alt="Logo SMS-APP" className="rounded-circle" style= {{width: '7%'}} src="/SMS-APP.png" />
                <h2 style={{fontSize: '20px'}} className="font-weight-bold text-white"> SMS APP</h2>
                <button ref={btnClose} style={{backgroundColor: 'white'}} type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
        </div>
            <div className='modal-body text-center text-color'>
                <h6 className="text-color mb-4" style={{fontSize: '13px'}}>
                    Escribe tus números de teléfono separados por coma o agrega un grupo para enviar tu mensaje de forma masiva.
                </h6>
            
                <div className="form-group bg-white px-2 py-2 mb-2 border-message">
                    <div className="row">
                        <div className="col">      
                            <div id='messageCreate' ref={divMessageCreateRef} style={{fontSize: '13px'}}>
                                {contentMessage}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                   <div className="col ">
                      <span className='conts'>Caracteres: {charactersCount}</span><span className='conts'>Créditos: {creditsCount}</span>     
                    </div>
                </div>
            </div>

        <div className='modal-footer text-center'>
            <div ref={divCelphonesRef} style= {{marginRight: '12px'}}>
                <p style={{fontSize:'10px', paddingRight:'72px', maxHeight: '2px'}}>Números de telefono destino separados por coma</p>
                <TagInputs idUser= {user._id} select={false} restart={restartTags} start={start} />
            </div>
            
            <div ref={divGroupsRef}>
                <p style={{fontSize:'10px', paddingTop:'5px', maxHeight: '2px', paddingRight:'200px'}}>Selección de grupos</p>
                <TagInputs idUser= {user._id} display= {'none'} select={true} restart={restartTags} start={start}/>
            </div>
            <br />
            {!sending && <button className='btn btn-sm btn-primary' onClick={handleMessage}>Enviar <i class="fas fa-paper-plane"></i></button>}
            {sending && <button class="btn btn-primary" type="button" disabled>
                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                Enviando...<i class="fas fa-paper-plane"></i>
            </button>}
        </div>
  </>
  )
}

export default ModalAuthMessage
